import { DELETE, SET } from "vuelpers/lib/vuex"
import { ClientsAPI, ExpertAdmins, RequestsAPI } from "../../firebase/api.firebase"
import { createGetters, createMutations, handleAction } from "vuelpers"

const initialState = () => ({
	isSubscribed: false,
	requests: [],
	request: { id: null },
	clients: {
		total: 0,
		data: []
	},
	expertAdmins: {
		total: 0,
		data: []
	}
})

const state = initialState()
const mutations = createMutations(SET, DELETE)
const getters = createGetters('request', "requests", 'clients', 'expertAdmins')

const actions = {
	async getExpertAdmins({ commit, state }) {
		if (state.expertAdmins.length) return state.expertAdmins
		return handleAction(
			ExpertAdmins.get({ page: 1, perPage: 100 }),
			res => commit('SET', { expertAdmins: res })
		)
	},
	async getClients({ commit, state }) {
		if (state.clients.length) return state.clients
		return handleAction(
			ClientsAPI.get({ page: 1, perPage: 100 }),
			res => commit('SET', { clients: res })
		)
	},
	subscribeRequests({ commit, state }) {
		if (state.isSubscribed) return

		handleAction(RequestsAPI.get(), res => {
			console.log(res)
		})

		RequestsAPI.onAdded(res => {
			console.log('onAdded', res)
		})

		RequestsAPI.onUpdated(res => {
			console.log('onUpdated', res)
		})

		commit(SET, { isSubscribed: true })
		RequestsAPI.onSnapshot(([error, requests]) => {
			!error && commit(SET, { requests })
		})
	},
	deleteRequest({ commit }, payload) {
		return handleAction(
			RequestsAPI.remove(payload), () => {
				commit(DELETE, ['requests', payload])
			}
		)
	},
	resetState({ commit }) {
		commit(SET, initialState())
	}
}

export default {
	state,
	actions,
	getters,
	mutations,
	namespaced: true
}
